<template>
  <div
    class="produce_jd_qr"
    v-loading="loading"
    element-loading-text="加载中"
    :key="activeName"
  >
    <div
      v-if="data.length > 0 && show_data != 'resume_management'"
      ref="echarts"
      class="con"
    ></div>
    <div
      v-if="data.length > 0 && show_data == 'resume_management'"
      class="resume_management"
    >
      <div ref="eachart_0"></div>
      <div ref="eachart_1"></div>
    </div>
    <div v-if="data.length == 0" class="kong">暂无数据</div>
    <el-button
      type="warning"
      size="mini"
      style="margin: 0px 12px"
      @click="changeBtn"
      >查看详情</el-button
    >
    <div class="tablePage" v-if="is_table" v-loading="tabLoading">
      <el-select
        v-model="is_online"
        placeholder="请选择线上线下"
        style="float: left; width: 200px; margin: 12px 0"
        v-if="show_data == 'resume_management'"
        @change="listData()"
      >
        <el-option label="线上" :value="0"> </el-option>
        <el-option label="线下" :value="1"> </el-option>
      </el-select>
      <el-table :data="tableData" style="width: 90%; margin-bottom: 20px">
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          align="center"
          v-for="(item, i) in title[show_data]"
          :key="i"
        >
          <template slot-scope="scope">
            <div
              v-if="item.prop == 'career_progress'"
              :style="{ color: list_1[scope.row.career_progress].color }"
            >
              {{ list_1[scope.row.career_progress].text }}
            </div>
            <div v-else>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentChange"
        :total="total"
        :page-size="pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  name: "produce_jd_qr",
  props: ["activeName", "show_data"],
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      loading: true,
      data: [],
      tableData: [],
      list_1: [
        {
          id: 0,
          text: "未选择",
          color: "#9a9a9a",
        },
        {
          id: 1,
          text: "急需找工作",
          color: "#f00",
        },
        {
          id: 2,
          text: "随便看看",
          color: "#e2a826",
        },
        {
          id: 3,
          text: "考虑机会",
          color: "#1296db",
        },
        {
          id: 4,
          text: "暂不考虑",
          color: "#9a9a9a",
        },
      ],
      title: {
        radar_status: [
          {
            prop: "career_progress",
            label: "求职状态",
          },

          {
            prop: "nick_name",
            label: "姓名",
          },
          {
            prop: "phone",
            label: "手机号",
          },
          {
            prop: "create_time",
            label: "创建时间",
          },
        ],
        liechang_status: [
          {
            prop: "career_progress",
            label: "求职状态",
          },
          {
            prop: "name",
            label: "姓名",
          },
          {
            prop: "phone",
            label: "手机号",
          },
          {
            prop: "resume_liechang_time",
            label: "简历更新时间",
          },
          {
            prop: "create_time",
            label: "简历下载时间",
          },
        ],
        resume_management: [
          {
            prop: "career_progress",
            label: "求职状态",
          },
          {
            prop: "name",
            label: "姓名",
          },
          {
            prop: "phone",
            label: "手机号",
          },
          {
            prop: "create_time",
            label: "创建时间",
          },
          {
            prop: "expect_position_name_str",
            label: "投递职位",
          },
        ],
      },
      total: 1000,
      page: 1,
      is_table: false,
      is_online: 0,
      pageSize: 15,
      tabLoading: true,
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {
    activeName() {
      this.loading = true;
      this.is_table = false;
      this.getData();
      this.listData();
    },
    show_data() {
      this.loading = true;
      this.is_table = false;
      this.getData();
      this.listData();
    },
  },
  //存放方法集合
  methods: {
    changeBtn() {
      this.is_table = !this.is_table;
      if (this.is_table) {
        this.listData();
      }
    },
    handleClick() {
      this.getData();
    },
    produce_jd_qr(name, ele, series_data) {
      console.log("简历来源", ele, series_data);
      this.$echarts.init(ele).setOption({
        // title: {
        //   text: "简历总浏览量",
        //   //   left: "center",
        // },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
        },

        series: [
          {
            name,
            type: "pie",
            radius: "50%",
            data: series_data,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "outer",
                  fontSize: 16,
                  formatter: "{b} : {c}份  ({d}%)",
                },
              },
            },
          },
        ],
      });
    },
    getData() {
      console.log("简历来源");
      let obj = {
        user_detail_id: this.$route.query.id,
        day_week: this.activeName,
        show_data: this.show_data,
      };
      require("POST", "/hr24_index_data/v1/user_data_detail/", obj).then(
        (res) => {
          if (!res.code) {
            this.loading = false;
            let data_0 = res.data[0];
            let serives_data = [[], []];
            if (res.data.length == 2) {
              let data_1 = res.data[1];
              for (let key in data_0) {
                serives_data[0].push({
                  name: key,
                  value: data_0[key],
                });
              }
              for (let key in data_1) {
                serives_data[1].push({
                  name: key || "未填写",
                  value: data_1[key],
                });
              }
              this.data = serives_data[0];
              this.$nextTick(() => {
                this.produce_jd_qr(
                  "简历标签",
                  this.$refs.eachart_0,
                  serives_data[0]
                );
                this.produce_jd_qr(
                  "简历来源",
                  this.$refs.eachart_1,
                  serives_data[1]
                );
              });
            } else {
              for (let key in data_0) {
                serives_data[0].push({
                  name: key,
                  value: data_0[key],
                });
              }
              this.data = serives_data[0];
              this.$nextTick(() => {
                this.produce_jd_qr(
                  "简历标签",
                  this.$refs.echarts,
                  serives_data[0]
                );
              });
            }
          }
        }
      );
    },
    currentChange(val) {
      this.page = val;
      this.listData();
    },
    listData() {
      this.tabLoading = true;
      let obj = {
        user_detail_id: this.$route.query.id,
        page: this.page,
        day_week: this.activeName,
      };
      if (this.show_data == "radar_status") {
        require("POST", "/hr24_index_data/v1/user_radar_list/", obj).then(
          (res) => {
            if (!res.code) {
              this.tableData = res.data.radar_list;
              this.total = res.data.radar_count;
              this.tabLoading = false;
            }
          }
        );
      }
      if (this.show_data == "resume_management") {
        obj.is_online = this.is_online;
        require("POST", "/hr24_index_data/v1/user_resume_management/", obj).then(
          (res) => {
            if (!res.code) {
              this.tableData = res.data.resume_list;
              this.total = res.data.all_counts;
              this.tabLoading = false;
            }
          }
        );
      }
      if (this.show_data == "liechang_status") {
        this.pageSize = 20;
        require("POST", "/hr24_index_data/v1/user_liechang_resume_list/", obj).then(
          (res) => {
            if (!res.code) {
              this.tableData = res.data.resume_list;
              this.total = res.data.count;
              this.tabLoading = false;
            }
          }
        );
      }
    },
  },
  //数据初始化之后
  created() {
    console.log("简历加载创建");
  },
  //页面渲染之后
  mounted() {
    this.getData();
  },
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */

.produce_jd_qr {
  padding: 60px 20px 20px;
  min-height: 400px;
}

.produce_jd_qr > p {
  float: left;
  width: 150px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin: 0;
  border: #fff solid 2px;
  background: rgb(140, 174, 236);
}
.produce_jd_qr .con {
  width: 100%;

  height: 400px;
}
.kong {
  text-align: center;
  font-size: 20px;
  line-height: 400px;
  color: #ccc;
}
.resume_management {
  width: 100%;
}
.resume_management div {
  float: left;

  width: 49%;
  height: 400px;
}
.tablePage {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/recruitmentData/resumeLaiyuan.vue